import { useNavigate } from "react-router-dom";
import CustomButton from "../../../../components/custom/button";
import { getPastOrderListAsync } from "../../../../../app/slices/pastOrderSlice/PastOrderSlice";
import { useAppDispatch, useAppSelector } from "../../../../../app/redux/hooks";
import { useEffect, useState } from "react";
import { getPastOrderDataDetailsAsync } from "../../../../../app/slices/checkoutSlice/CheckoutSlice";
import { CircularProgress,useMediaQuery } from "@mui/material";
import React from "react";
import CustomDialog from "../../../../components/custom/dialog";
import { HelpPage } from "./HelpPage";
import { getProductImageUrl } from "../../../../../app/slices/common/imageConstants";

export const Orders = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [modalType, setModalType] = React.useState("");
  const isMobileScreen = useMediaQuery("(max-width:765px)");
  const orderData = useAppSelector((state) => state.PastOrderState);
  const onViewDetails = (uuid: any, order_type: any) => {
    // if (order_type === "Custom Orders") {
    //   localStorage.setItem("custom_order_uuid", uuid);
    //   navigate("/custom-order-submitted");
    // } else {
    localStorage.setItem("order_uuid", uuid);
    navigate("/order-confirmation");
    // }

    // dispatch(getPastOrderDataDetailsAsync(uuid)).then((response: any) => {
    //   if (response?.payload?.status === 200) {
    //     navigate("/order-confirmation");
    //   }
    // });
  };
  const convertDate = (dateString: Date) => {
    if (dateString) {
      const date = new Date(dateString);
      const formattedDate = date.toLocaleDateString("en-US", {
        weekday: "short", // Abbreviated weekday (e.g., "Sun")
        year: "numeric",
        month: "short", // Abbreviated month (e.g., "Dec")
        day: "numeric",
      });
      return formattedDate;
    }
    return "";
  };

  const convertTimeTo12HourFormat = (time: string): string => {
    if (time !== "Not Provided") {
      const [hours, minutes] = time.split(":").map(Number);
      const isPM = hours >= 12;
      const formattedHours = hours % 12 || 12; // Converts 00:00 to 12:00 for midnight
      const formattedMinutes = minutes?.toString().padStart(2, "0");
      const period = isPM ? "PM" : "AM";

      return `${formattedHours}:${formattedMinutes} ${period}`;
    } else return "";
  };

  const DateFormat = () => {
    const date = new Date("2024-12-12");

    const formattedDate = date.toLocaleDateString("en-US", {
      weekday: "short", // Abbreviated weekday (e.g., "Sun")
      year: "numeric",
      month: "short", // Abbreviated month (e.g., "Dec")
      day: "numeric",
    });
  };
  useEffect(() => {
    dispatch(getPastOrderListAsync());
  }, []);

  const onOpenModal = (type: string) => {
    setModalType(type);
  };
  const onCloseModal = () => {
    setModalType("");
  };
  const handleHelpButton = () => {
    onOpenModal("help");
  };
  return (
    <>
      <div
        className="my-account-content account-order"
        style={{
          fontFamily: "Albert Sans, sans-serif",
          fontSize: "14px",
          lineHeight: "22px",
          fontWeight: "400",
        }}
      >
        <h4 className="title-right">Past Orders</h4>
        {orderData?.orderInfoData?.loader ? (
          <div className="wrap-account-order" style={{ minHeight: "50vh" }}>
            <CircularProgress
              style={{
                position: "absolute",
                // top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
            />
          </div>
        ) : (
          <>
            <div className="wrap-account-order">
              {orderData?.orderInfoData?.data.map((item: any, index: any) => {
                return (
                  <div key={index} className="card mb-3">
                    <div className="card-body">
                      <div className="row align-items-center">
                        <div className="col-md-2">
                          <img
                            data-src={getProductImageUrl(item?.product_image)}
                            src={getProductImageUrl(item?.product_image)}
                            className="img-fluid"
                            alt=""
                          />
                        </div>
                        <div className={`col-md-10 ${isMobileScreen ? "mt-3" : ""}`}>
                          <div className="d-flex justify-content-between align-items-center">
                            <div className="col-md-9">
                              <p className="address-text">
                                <b>Order ID:</b> {item?.order_ID}
                                {item?.delivery_slot_date && (
                                  <>
                                    | {convertDate(item?.delivery_slot_date)},
                                    {convertTimeTo12HourFormat(
                                      item?.delivery_slot_time
                                    )}
                                  </>
                                )}
                              </p>
                              {item?.order_status === "Delivered" ? (
                                <p className="mt-2 address-text address-text">
                                  Delivered on:{" "}
                                  {convertDate(item?.delivery_slot_date)},
                                  {convertTimeTo12HourFormat(
                                    item?.delivery_slot_time
                                  )}
                                  <img
                                    src="/shopnow/images/tick.svg"
                                    width="15"
                                    alt=""
                                  />
                                </p>
                              ) : (
                                ""
                              )}
                              {item?.order_status !== "Delivered" ? (
                                <p
                                  className="my-2 green-success"
                                  style={{ color: "#94969F" }}
                                >
                                  Status: {item?.order_status === "Bill Created" ? "Proforma Invoice Created" : item?.order_status}{" "}
                                </p>
                              ) : (
                                ""
                              )}{" "}
                              <p className="mt-2 address-text address-text">
                                {item?.product_names.length !== 0 && (
                                  <>
                                    Products:{" "}
                                    {item?.product_names.map(
                                      (product: any, index: any) => (
                                        <span key={index}>
                                          {product}
                                          {", "}
                                        </span>
                                      )
                                    )}
                                  </>
                                )}
                              </p>
                              <button
                                className="btn-help"
                                // data-bs-toggle="modal"
                                style={{ marginTop: "1rem", cursor: "pointer" }}
                                onClick={() => handleHelpButton()}
                              >
                                Help
                              </button>
                            </div>
                            <div className="text-end col-md-3">
                              <CustomButton
                                size="medium"
                                fullWidth
                                onClick={() =>
                                  onViewDetails(item.uuid, item.order_type)
                                }
                                name="View Details"
                              />
                              {/* <a
                      type=""
                      className="tf-btn w-100 radius-3 btn-fill animate-hover-btn justify-content-center"
                    >
                      View Details
                    </a> */}
                              <p className="mt-3 address-text">
                                {item.grand_total && (
                                  <b>
                                    {item.order_status === "Bill Created" || item.order_status === "Failed"
                                      ? "Amount Due"
                                      : "Total Paid"}
                                    : ₹{item.grand_total}
                                  </b>
                                )}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            {orderData?.orderInfoData?.data?.length === 0 && (
              <div
                style={{
                  fontSize: "18px",
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <span className="title wow fadeInUp" data-wow-delay="0s">
                  No data found
                </span>
              </div>
            )}
          </>
        )}
      </div>
      <CustomDialog
        component={<HelpPage />}
        title=""
        openDialog={modalType === "help"}
        handleCloseDialog={onCloseModal}
        modalPlace="center"
      />
    </>
  );
};
